import { AmDateFormat, EuDateFormat, NewDateFormat } from './rx-datepicker-directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { IMaskModule } from 'angular-imask';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { NgModule } from '@angular/core';
import { RxDatepickerComponent } from './rx-datepicker.component';
import { RxDatepickerWithInputModule } from '@nrwl/rx-datepicker-with-input';
import { RxInputDatepickerComponent } from './rx-input-datepicker';

@NgModule({
  imports: [
    CommonModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatMomentDateModule,
    IMaskModule,
    RxDatepickerWithInputModule,
    AmDateFormat,
    RxInputDatepickerComponent,
    RxDatepickerComponent,
    NewDateFormat,
    EuDateFormat,
  ],
  exports: [
    RxInputDatepickerComponent,
    RxDatepickerComponent,
    NewDateFormat,
    EuDateFormat,
    AmDateFormat,
  ],
})
export class RxDatepickerModule {}
